
const initialState = () => ({
    isEdit: false,
    product_form: {
        id:"",
        NAME: "",
        PRICE: 0,
        UNIT: "",
        TYPE: "",
        CATEGORY: "",
        DETAIL: "",
    },
});

const state = initialState()


const getters = {
    GET_ELEMENT: state => state.product_form,
    IS_EDIT: state => state.isEdit,

}

const mutations = {
    SET_ALL_ELEMENT(state, data) {
        state.product_form = Object.assign({}, data);
    },
    SET_ELEMENT(state, data) {
        state.product_form[data.key] = data.value;
    },
    SET_IS_EDIT(state, data) {
        state.isEdit = data
    },
    RESET(state) {
        const newState = initialState();
        Object.keys(newState).forEach(key => {
            state[key] = newState[key]
        });
    },

}

const actions = {

    reset({ commit }) {
        commit('RESET');
    }
}
// Mutations

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}